module.exports = __webpack_public_path__ + "rentalsunited-fav-icon.png?bc98f714e7878827169ccdc5f5b10d20";